//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

module.exports.gagoPaint = {
    "lercv2": {
        "raster-opacity": {
            "type": "number",
            "doc": "The opacity at which the image will be drawn.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            },
            "expression": {
                "interpolated": true,
                "parameters": [
                  "zoom"
                ]
              },
              "property-type": "data-constant"
        },
        "raster-hue-rotate": {
            "type": "number",
            "default": 0,
            "period": 360,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "degrees",
            "doc": "Rotates hues around the color wheel.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-min": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the minimum brightness.",
            "default": 0,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-max": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the maximum brightness.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-saturation": {
            "type": "number",
            "doc": "Increase or reduce the saturation of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            },
            "expression": {
                "interpolated": true,
                "parameters": [
                  "zoom"
                ]
              },
              "property-type": "data-constant"
        },
        "raster-contrast": {
            "type": "number",
            "doc": "Increase or reduce the contrast of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-fade-duration": {
            "type": "number",
            "default": 300,
            "minimum": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "milliseconds",
            "doc": "Fade duration when a new tile is added.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-max": {
            "type": "number",
            "default": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": false,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-min": {
            "type": "number",
            "default": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": false,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-colorscale": {
            "type": "colorscale",
            "default": "ndvi",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "lerc-clamp-low": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data lower than minvalule"
        },
        "lerc-clamp-high": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data higher than minvalule"
        },
        "clamp-high-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": false,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "clamp-low-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": false,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "lerc-mask-source": {
            "type": "string",
            "doc": "lerc mask source"
        },
        "geojson-mask-source": {
            "type": "string",
            "doc": "geojson mask source"
        },
        "lerc-include": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-exclude": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value exclude array"
        },
        "lerc-mask-include": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-exclude": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "image-geojson-mask": {
            "type": "boolean",
            "default": false,
            "doc": "whether use lerc-image-source geojson-mask"
        },
        "is-image": {
            "type": "boolean",
            "default": false,
            "doc": "whether draw like image"
        },
        "invalid-color": {
            "type": "color",
            "default": "rgba(0,0,0,0)"
        },
        "mask-color": {
            "type": "color",
            "default": "rgba(0,0,0,0)"
        },
        "mask-mix": {
            "type": "number",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
        },
    },
    "lerc-3d": {
        "pixels": {
            "type": "enum",
            "values": {
                "1": {},
                "2": {},
                "4": {},
                "8": {},
                "16": {},
                "32": {},
                "64": {},
                "128": {}
            },
            "default": "8"
        },
        "raster-opacity": {
            "type": "number",
            "doc": "The opacity at which the image will be drawn.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            },
            "expression": {
                "interpolated": true,
                "parameters": [
                  "zoom"
                ]
              },
              "property-type": "data-constant"
        },
        "raster-domain-max": {
            "type": "number",
            "default": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-min": {
            "type": "number",
            "default": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-colorscale": {
            "type": "colorscale",
            "default": "ndvi",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "height-base": {
            "type": "number",
            "default": 0
        },
        "height-factor": {
            "type": "number",
            "minimum": 0,
            "default": 1
        },
        "texture-source": {
            "type": "string"
        },
        "texture-type": {
            "type": "enum",
            "default": "0",
            "values": {
                "0": {},
                "1": {}
            }
        },
        "vertex-type": {
            "type": "enum",
            "default": "bar",
            "values": {
                "triangle": {},
                "bar": {}
            }
        },
        "clamp-high-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "clamp-low-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        }
    },
    "lerc-terrain": {
        "raster-opacity": {
            "type": "number",
            "doc": "The opacity at which the image will be drawn.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            },
            "expression": {
                "interpolated": true,
                "parameters": [
                  "zoom"
                ]
              },
              "property-type": "data-constant"
        },
        "raster-hue-rotate": {
            "type": "number",
            "default": 0,
            "period": 360,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "degrees",
            "doc": "Rotates hues around the color wheel.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-min": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the minimum brightness.",
            "default": 0,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-max": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the maximum brightness.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-saturation": {
            "type": "number",
            "doc": "Increase or reduce the saturation of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-contrast": {
            "type": "number",
            "doc": "Increase or reduce the contrast of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-fade-duration": {
            "type": "number",
            "default": 300,
            "minimum": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "milliseconds",
            "doc": "Fade duration when a new tile is added.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-max": {
            "type": "number",
            "default": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-min": {
            "type": "number",
            "default": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-colorscale": {
            "type": "colorscale",
            "default": "ndvi",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "lerc-clamp-low": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data lower than minvalule"
        },
        "lerc-clamp-high": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data higher than minvalule"
        },
        "clamp-high-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "clamp-low-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "lerc-mask-source": {
            "type": "string",
            "doc": "lerc mask source"
        },
        "geojson-mask-source": {
            "type": "string",
            "doc": "geojson mask source"
        },
        "lerc-include": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-exclude": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value exclude array"
        },
        "lerc-mask-include": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-exclude": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "draw-type": {
            "type": "enum",
            "default": "normal",
            "values": {
                "normal": {},
                "shadow": {},
                "slope": {},
                "3d": {},
                "aspect": {}
            }
        },
        "zenith": {
            "type": "number",
            "default": 45,
            "minimum": 0,
            "maximum": 90
        },
        "azimuth": {
            "type": "number",
            "default": 335,
            "minimum": 0,
            "maximum": 360
        },
        "image-geojson-mask": {
            "type": "boolean",
            "default": false,
            "doc": "whether use lerc-image-source geojson-mask"
        },
    },
    "lerc-overlay": {
        "raster-opacity": {
            "type": "number",
            "doc": "The opacity at which the image will be drawn.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            },
            "expression": {
                "interpolated": true,
                "parameters": [
                  "zoom"
                ]
              },
              "property-type": "data-constant"
        },
        "raster-hue-rotate": {
            "type": "number",
            "default": 0,
            "period": 360,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "degrees",
            "doc": "Rotates hues around the color wheel.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-min": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the minimum brightness.",
            "default": 0,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-max": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the maximum brightness.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-saturation": {
            "type": "number",
            "doc": "Increase or reduce the saturation of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-contrast": {
            "type": "number",
            "doc": "Increase or reduce the contrast of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-fade-duration": {
            "type": "number",
            "default": 300,
            "minimum": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "milliseconds",
            "doc": "Fade duration when a new tile is added.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-max": {
            "type": "number",
            "default": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-min": {
            "type": "number",
            "default": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-colorscale": {
            "type": "colorscale",
            "default": "ndvi",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "lerc-clamp-low": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data lower than minvalule"
        },
        "lerc-clamp-high": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data higher than minvalule"
        },
        "clamp-high-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "clamp-low-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        // "lerc-mask-source": {
        //     "type": "array",
        //     "value": {
        //         "type": "string",
        //         "doc": "A float value"
        //     },
        //     "doc": "lerc mask source"
        // },
        "lerc-mask-source-1": {
            "type": "string",
            "doc": "lerc mask source"
        },
        "lerc-mask-source-2": {
            "type": "string",
            "doc": "lerc mask source"
        },
        "lerc-mask-source-3": {
            "type": "string",
            "doc": "lerc mask source"
        },
        "lerc-mask-source-4": {
            "type": "string",
            "doc": "lerc mask source"
        },
        // "lerc-mask-source-5": {
        //     "type": "string",
        //     "doc": "lerc mask source"
        // },
        "geojson-mask-source": {
            "type": "string",
            "doc": "geojson mask source"
        },
        "lerc-include": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-exclude": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value exclude array"
        },
        // "lerc-mask-include": {
        //     "type": "array",
        //     "value": {
        //         "type": "array",
        //         "length": 2,
        //         "value": "number",
        //         "doc": "A float value"
        //     },
        //     "doc": "lerc valid value include array"
        // },
        "lerc-mask-include-1": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-include-2": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-include-3": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-include-4": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        // "lerc-mask-include-5": {
        //     "type": "array",
        //     "value": {
        //         "type": "array",
        //         "length": 2,
        //         "value": "number",
        //         "doc": "A float value"
        //     },
        //     "doc": "lerc valid value include array"
        // },
        // "lerc-mask-exclude": {
        //     "type": "array",
        //     "value": {
        //         "type": "array",
        //         "length": 2,
        //         "value": "number",
        //         "doc": "A float value"
        //     },
        //     "doc": "lerc valid value include array"
        // },
        "lerc-mask-exclude-1": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-exclude-2": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-exclude-3": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-exclude-4": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        // "lerc-mask-exclude-5": {
        //     "type": "array",
        //     "value": {
        //         "type": "array",
        //         "length": 2,
        //         "value": "number",
        //         "doc": "A float value"
        //     },
        //     "doc": "lerc valid value include array"
        // },
        "image-geojson-mask": {
            "type": "boolean",
            "default": false,
            "doc": "whether use lerc-image-source geojson-mask"
        },
    },
    "lerc-grid": {
        "doc": "Raster map textures such as satellite imagery.",
        "scale": {
            "type": "number",
            "doc": "lerc grid scale number"
        },
        "density": {
            "type": "number",
            "doc": "one tile square's lerc grid's number(density*density)."
        },
        "baseValue": {
            "type": "number",
            "doc": "the base line value when calculate height is real value subracted the baseValue."
        },
        "min": {
            "type": "number",
            "doc": "the lowest value which value lower than this can not be render."
        },
        "max": {
            "type": "number",
            "doc": "the largest value which value lower than this can not be render."
        },
        "opacity": {
            "type": "number",
            "doc": "lerc grid opacity number"
        },
        "sdk-support": {
            "basic functionality": {
                "js": "0.10.0",
                "android": "2.0.1",
                "ios": "2.0.0",
                "macos": "0.1.0"
            }
        }
    },
    "lerc-compare": {
        "raster-opacity": {
            "type": "number",
            "doc": "The opacity at which the image will be drawn.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            },
            "expression": {
                "interpolated": true,
                "parameters": [
                  "zoom"
                ]
              },
              "property-type": "data-constant"
        },
        "raster-hue-rotate": {
            "type": "number",
            "default": 0,
            "period": 360,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "degrees",
            "doc": "Rotates hues around the color wheel.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-min": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the minimum brightness.",
            "default": 0,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-brightness-max": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "doc": "Increase or reduce the brightness of the image. The value is the maximum brightness.",
            "default": 1,
            "minimum": 0,
            "maximum": 1,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-saturation": {
            "type": "number",
            "doc": "Increase or reduce the saturation of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-contrast": {
            "type": "number",
            "doc": "Increase or reduce the contrast of the image.",
            "default": 0,
            "minimum": -1,
            "maximum": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-fade-duration": {
            "type": "number",
            "default": 300,
            "minimum": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "units": "milliseconds",
            "doc": "Fade duration when a new tile is added.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-max": {
            "type": "number",
            "default": 1,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-domain-min": {
            "type": "number",
            "default": 0,
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "raster-colorscale": {
            "type": "colorscale",
            "default": "ndvi",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "appear-color": {
            "type": "color",
            "default": "#000000"
        },
        "disappear-color": {
            "type": "color",
            "default": "#000000"
        },
        "same-color": {
            "type": "color",
            "default": "#000000"
        },
        "diff-color": {
            "type": "color",
            "default": "#000000"
        },
        "increase-color": {
            "type": "color"
        },
        "decrease-color": {
            "type": "color"
        },
        "diff-range-min": {
            "type": "number",
            "default": 0
        },
        "diff-range-max": {
            "type": "number",
            "default": 0
        },
        "lerc-include": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-clamp-low": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data lower than minvalule"
        },
        "lerc-clamp-high": {
            "type": "boolean",
            "default": true,
            "doc": "whether draw when lerc data higher than minvalule"
        },
        "clamp-high-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian max-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "clamp-low-value": {
            "type": "number",
            "function": "interpolated",
            "zoom-function": true,
            "transition": true,
            "doc": "lerc domian min-value to cacu colorscale.",
            "sdk-support": {
                "basic functionality": {
                    "js": "0.10.0",
                    "android": "2.0.1",
                    "ios": "2.0.0",
                    "macos": "0.1.0"
                },
                "data-driven styling": {}
            }
        },
        "lerc-mask-source": {
            "type": "string",
            "doc": "lerc mask source"
        },
        "lerc-compare-source": {
            "type": "string",
            "doc": "lerc mask source"
        },
        "geojson-mask-source": {
            "type": "string",
            "doc": "geojson mask source"
        },
        "lerc-exclude": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value exclude array"
        },
        "lerc-mask-include": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "lerc-mask-exclude": {
            "type": "array",
            "value": {
                "type": "array",
                "length": 2,
                "value": "number",
                "doc": "A float value"
            },
            "doc": "lerc valid value include array"
        },
        "draw-type": {
            "type": "enum",
            "default": "normal",
            "values": {
                "normal": {},
                "compare": {}
            }
        },
        "image-geojson-mask": {
            "type": "boolean",
            "default": false,
            "doc": "whether use lerc-image-source geojson-mask"
        },
    },
};

module.exports.mapboxPaint = {
    "raster": {
        "geojson-mask-source": {
            "type": "string",
            "doc": "geojson mask source"
        },
    }
};
